module.exports = __webpack_public_path__ + "img/COMP.152a1c61.svg";